import baustein from "baustein";
import Tooltip from "web/react/components/tooltip/tooltip";
import renderReactComponentInDocument from "web/script/utils/render-react";

export default baustein.register("react-tooltip", {
    defaultOptions: {
        direction: "bottom",
        arrow: true,
        autoShow: false,
        autoHide: false,
    },

    onInsert() {
        renderReactComponentInDocument(
            Tooltip,
            {
                ...this.options,
                children: this.el.innerHTML,
            },
            this.el
        );
    },
});
